import { z } from 'zod';

/** Libera, por viajante, o KM pago pelo trajeto medido por GPS em vez da rota de carro entre o
 *  check-in e o check-out. Só vale com o rastreado liberado. */
export const KM_GPS_FEATURE_FLAGS = ['use_intelligence_km_gps'] as const;

export interface KmTrackedAccessInput {
  /** `policyAccess` do lookup contém `expenseKm`; `null` = não resolvido. */
  kmPolicy: boolean | null;
  /** `currentFeatures(USER_APP)` filtradas; `null` = não resolvido (sem GPS). */
  featureFlags: readonly string[] | null;
  /** Bloqueio de gastos confirmado; `null`/ausente = não confirmado (não esconde). */
  spendingBlocked?: boolean | null;
}

// `gps` só existe ligado: o `/me` é lido em modo estrito por bundles antigos do web-chat.
export const KmTrackedEntrySchema = z
  .object({ offer: z.boolean(), gps: z.literal(true).optional() })
  .strict();
export type KmTrackedEntry = z.infer<typeof KmTrackedEntrySchema>;

const HIDDEN: KmTrackedEntry = { offer: false };

/**
 * Se o trajeto rastreado aparece: a política `expenseKm`. Não lê a "Solicitação sem rastreamento"
 * (`untrackedRoute`): ela só libera o KM manual, e no app clássico o rastreado existe com ela
 * desligada. `gps` vem junto quando a flag do GPS está ligada; flags não resolvidas = sem GPS.
 */
export function kmTrackedEntry(input: KmTrackedAccessInput): KmTrackedEntry {
  const { kmPolicy, featureFlags, spendingBlocked } = input;
  if (kmPolicy !== true || spendingBlocked === true) return HIDDEN;
  const gps = KM_GPS_FEATURE_FLAGS.every((flag) => featureFlags?.includes(flag) === true);
  return gps ? { offer: true, gps: true } : { offer: true };
}
